import { useTranslation } from 'react-i18next'

import { RowItemTypes } from './types'

import { Copy } from '@/components/Copy'
import { BaseText, BaseView } from '@/components/base'

export const RowItem = ({
  label,
  value,
  secondaryValue,
  labelProps,
  valueProps,
  skeletonActive = false,
  showSeparator = false,
  separatorGap = 8,
  IconComponent,
  isCopyable,
  copyValue,
}: RowItemTypes) => {
  const { t } = useTranslation()

  return (
    <BaseView gap={separatorGap}>
      <BaseView
        row
        justify="space-between"
        align="center"
        style={{ width: '100%' }}
      >
        <BaseView row align="center" gap={6}>
          <BaseText
            fontFamily="semibold"
            skeletonActive={skeletonActive}
            skeletonWidth={120}
            translationKey={label}
            color="label.description"
            {...labelProps}
          />
          {!!IconComponent && !skeletonActive && <>{IconComponent}</>}
        </BaseView>

        <BaseView row align="center" gap={8}>
          <BaseView align="flex-end" gap={6}>
            <BaseText
              fontFamily="semibold"
              skeletonActive={skeletonActive}
              skeletonWidth={80}
              {...valueProps}
            >
              {value}
            </BaseText>
            {!!secondaryValue && (
              <BaseText
                fontFamily="medium"
                color="label.description"
                fontSize={14}
              >
                {secondaryValue}
              </BaseText>
            )}
          </BaseView>

          {isCopyable && (
            <Copy
              toastMessage={`${t('translation:transactionId')} ${t('translation:copied')}`}
              copyValue={copyValue || value}
            />
          )}
        </BaseView>
      </BaseView>

      {showSeparator && (
        <BaseView
          style={{
            height: 2,
            width: '100%',
            backgroundColor: '#363638',
          }}
        />
      )}
    </BaseView>
  )
}
